import { render } from "./TripCreateForm.vue?vue&type=template&id=707a8d24&scoped=true"
import script from "./TripCreateForm.vue?vue&type=script&lang=js"
export * from "./TripCreateForm.vue?vue&type=script&lang=js"

import "./TripCreateForm.vue?vue&type=style&index=0&id=707a8d24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707a8d24"]])

export default __exports__